import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { CustomerContact, CustomerContactCreate, CustomerContactFilter } from '../data/customerContact';

export function createCustomerContactService(client: AxiosInstance) {
  return createCrudService<CustomerContact, CustomerContactCreate, CustomerContactFilter>(
    client,
    '/crm/CustomerContact',
    'id',
  );
}

export type CustomerContactService = CrudService<CustomerContact, CustomerContactCreate, CustomerContactFilter>;
